import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export default class CompanyService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    show(id) {
        return this.axios.get(this.route('admin.companies.show', { id }));
    }
    store(data) {
        return this.axios.post(this.route('admin.companies.store'), data);
    }
    update(id, data) {
        return this.axios.patch(this.route('companies.update', id), data);
    }
}
